import {
  flowA1Schemas,
  flowA2Schemas,
  flowBSchemas,
  flowCSchemas,
  flowDSchemas,
  flowESchemas,
  flowFSchemas,
  flowGSchemas,
  flowISchemas,
  flowZ1Schemas,
  flowZ2Schemas,
  flowK1Schemas,
  flowH1Schemas,
  schematizedTextSchemas,
} from 'components/Wizards/schemas/mobileSchemas'
import { Wizard } from 'components/Wizards/WizardsDrawer/WizardsDrawerV4/Types'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const useIsNewWizardFlowEnabled = () => {
  const flowA1Enabled = useFlipperFlag('mobile_redesign_wizard_A1')
  const flowBEnabled = useFlipperFlag('mobile_redesign_wizard_B')
  const flowCEnabled = useFlipperFlag('mobile_redesign_wizard_C')
  const flowDEnabled = useFlipperFlag('mobile_redesign_wizard_D')
  const flowEEnabled = useFlipperFlag('mobile_redesign_wizard_E')
  const flowFEnabled = useFlipperFlag('mobile_redesign_wizard_F')
  const flowGEnabled = useFlipperFlag('mobile_redesign_wizard_G')
  const flowIEnabled = useFlipperFlag('mobile_redesign_wizard_I')
  const flowK1Enabled = useFlipperFlag('mobile_redesign_wizard_K1')
  const flowZ1Enabled = useFlipperFlag('mobile_redesign_wizard_Z1')
  const flowZ2Enabled = useFlipperFlag('mobile_redesign_wizard_Z2')
  const flowH1Enabled = useFlipperFlag('mobile_redesign_wizard_H1')

  const flowConfigs = [
    [flowA1Schemas, flowA1Enabled],
    [flowA2Schemas, true],
    [flowBSchemas, flowBEnabled],
    [flowCSchemas, flowCEnabled],
    [flowDSchemas, flowDEnabled],
    [flowESchemas, flowEEnabled],
    [flowFSchemas, flowFEnabled],
    [flowGSchemas, flowGEnabled],
    [flowISchemas, flowIEnabled],
    [flowK1Schemas, flowK1Enabled],
    [flowZ1Schemas, flowZ1Enabled],
    [flowZ2Schemas, flowZ2Enabled],
    [flowH1Schemas, flowH1Enabled],
    [schematizedTextSchemas, true],
  ] as const

  const flowEnabledMap = new Map<Wizard, boolean>()

  flowConfigs.forEach(([schemas, enabledFlag]) => {
    Object.entries(schemas).forEach(([type]) => {
      const wizardType = type as Wizard
      const currentValue = flowEnabledMap.get(wizardType)
      flowEnabledMap.set(wizardType, currentValue === true || enabledFlag)
    })
  })

  return {
    isNewWizardFlowEnabled: (type: Wizard) => {
      return flowEnabledMap.get(type) ?? false
    },
  }
}
